import Api from "@/modules/shops/pages/shops/services/Api"

export default {
    data: {
        title: "Редактирование магазина",
        btn: "Редактировать",
        page: "update",
    },
    action: ({modal, payload}) => {
        return new Promise((resolve, reject) => {
            return Api.update(payload).then(() => {
                modal.hide();
                resolve("Отредактирован")
            }).catch(() => {
                reject("Ошибка при редактировании")
            }).finally(() => {})
        })
    }
}